import { array, boolean, number, object, string } from 'yup';
import { parseLithuanianPersonalCode } from '@app/lib/personal-code/parseLithuanianPersonalCode';

export const RequestPersonalAccidentsInsurance = object({
    discountCode: string().optional(),
    personalCode: string()
        .min(1, 'profile.validation.fieldRequired')
        .required('profile.validation.fieldRequired')
        .test(
            'is-valid-personal-code',
            'eshop.travel.validation.personalCodeInvalid',
            value => !!value && parseLithuanianPersonalCode(value).isValid,
        )
        .test('is-age-at-least-18', 'eshop.personalAccidents.validation.pr1Message', value => {
            if (!value) return false;
            const parsed = parseLithuanianPersonalCode(value);
            if (!parsed.isValid || !parsed.age) return false;
            return parsed.age >= 18;
        })
        .test('is-age-at-most-70', 'eshop.personalAccidents.validation.pr2Message', value => {
            if (!value) return false;
            const parsed = parseLithuanianPersonalCode(value);
            if (!parsed.isValid || !parsed.age) return false;
            return parsed.age <= 70;
        }),
    insuredPersons: array()
        .of(
            object({
                id: string().required(),
                age: number()
                    .min(1, 'profile.validation.fieldRequired')
                    .max(70, 'eshop.personalAccidents.validation.pr2Message')
                    .required('profile.validation.fieldRequired'),
                isPolicyholder: boolean().required(),
                name: string(),
                surname: string(),
                personalCode: string(),
            }),
        )
        .min(1)
        .required(),
    acceptPrivacyPolicy: boolean()
        .is([true], 'eshop.travel.validation.mustAcceptPrivacyPolicy')
        .required('profile.validation.fieldRequired'),
});
